import { InsurancePolicy } from '@advisory-report/src/types/AdvisoryReport';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';

export interface InsurencePoliciesResponse {
  items: InsurancePolicy[];
}

export interface InsurencePoliciesPartialResponse {
  items: Partial<InsurancePolicy>[];
}

interface Params {
  partyId: string;
  /** Will be the sessionId in most cases */
  simulationId: string;
}

const getInsurancePoliciesBySimulation = async ({
  partyId,
  simulationId,
}: Params) => {
  const { data, isError } = await wgApi.get<InsurencePoliciesResponse>(
    `/v1/api/parties/${partyId}/simulations/${simulationId}/insurance-policies`,
  );
  if (isError) throw new Error();
  return data;
};

export const getUseInsurancePoliciesBySimulationQKey = ({
  partyId,
  simulationId,
}: Params) => [
  'parties',
  'insurance-policies',
  'simulations',
  partyId,
  simulationId,
];

export const useInsurancePoliciesBySimulation = (params: Params) => {
  return useQuery(
    getUseInsurancePoliciesBySimulationQKey(params),
    () => getInsurancePoliciesBySimulation(params),
    {
      enabled: !!params.partyId && !!params.simulationId,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );
};
